import * as React from 'react';
import { EditableInputButtons } from './EditableInputButtons';

let tabPressed = false;
export class EditableTextBox extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            prevValue: this.props.value,
            value: this.props.value,
            editableButtonsVisibility: false,
            isCancelAction: false
        };

        this.handleCancelClick = this.handleCancelClick.bind(this);
        this.handleSaveClick = this.handleSaveClick.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.handleFocus = this.handleFocus.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    hasValueChanged() {
        return this.state.prevValue !== this.state.value;
    }

    handleChange(event) {
        this.setState({
            value: event.target.value
        });
    }

    handleCancelClick(event) {

        this.setState({
            value: this.state.prevValue,
            isCancelAction: true,
            editableButtonsVisibility: false
        });
        document.getElementById(this.props.id).value = this.state.prevValue;
    }

    handleSaveClick(event) {
        this.callSaveClick(event);
    }

    handleFocus() {
        this.setState({
            editableButtonsVisibility: true,
            isCancelAction: false
        });
    }

    handleKeyDown = function (e) {
        tabPressed = false;

        if (e.key === 'Tab') {
            tabPressed = true;
            this.onBlurAction();
        }
    }

    handleBlur(event) {
        if (tabPressed) {
            tabPressed = false;
        }
        else {
            this.onBlurAction();
        }
    }

    onBlurAction() {
        if (!this.state.isCancelAction) {
            this.callSaveClick();
        }
    }

    callSaveClick() {
        if (this.props.canEdit) {
            if (this.hasValueChanged())
                this.props.onSaveClick(this.state.value);
            this.setState({
                prevValue: this.state.value,
                editableButtonsVisibility: false,
                isCancelAction: false
            });
        }
    }

    renderEditableControls() {
        // AP-4833, it has been invisibled for bbc. We can use this feature for other broadcaster in future
        //if (this.props.canEdit) {
        //    return (
        //        <EditableInputButtons onSaveClick={this.handleSaveClick} onCancelClick={this.handleCancelClick} visible={this.state.editableButtonsVisibility} right='0' />
        //    );
        //}
        return '';
    }

    render() {
        return (
            <div>
                <textarea
                    className={`${this.props.className}`}
                    id={this.props.id}
                    name={this.props.name}
                    defaultValue={this.state.value}
                    cols={this.props.cols}
                    rows={this.props.rows}
                    onChange={this.handleChange}
                    autoComplete='off'
                    onFocus={this.handleFocus}
                    onBlur={this.handleBlur}
                    disabled={!this.props.canEdit}
                    maxLength={this.props.maxLength}
                    onKeyDown={(e) => { this.handleKeyDown(e); }}
                    aria-label={this.props.ariaLabel}
                />
                {this.renderEditableControls()}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Controls/EditableTextBox.js